import { render, staticRenderFns } from "./VolumeInput.vue?vue&type=template&id=70b9a564&scoped=true"
import script from "./VolumeInput.vue?vue&type=script&lang=js"
export * from "./VolumeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b9a564",
  null
  
)

export default component.exports